import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ClientStatePasswordGetActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class ClientStatePasswordGetEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getClientStatePasswordGet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientStatePasswordGetActions.getClientStatePasswordGet),
      switchMap((action) =>
        this.onboardingProductsService.getClientStatePassword().pipe(
          map((res) => this.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            ClientStatePasswordGetActions.getClientStatePasswordGetSuccess({ response: res })
          ),
          catchError((error) =>
            of(
              ClientStatePasswordGetActions.getClientStatePasswordGetError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

  responseInterpreter(res) {
    console.log('******** ResponseInterpreter Input', res);
    res = res['response'];
    const response = res;
    if (
      _.get(res, 'middleware.operationState.code', '') === '201' ||
      _.get(res, 'middleware.operationState.code', '') === '410' ||
      _.get(res, 'middleware.operationState.code', '') === '420'
    ) {
      if (_.get(res, 'middleware', null)) {
        response['middleware'] = _.get(res, 'middleware.operationState', null);
      }
    }
    console.log('******** ResponseInterpreter Return', response);
    return response;
  }
}
